import api from './api';
import Vue from 'vue';

import router from './router';

import vueResource from 'vue-resource';
import VueNoty from 'vuejs-noty';
import App from './App';
import store from '@/store';

import TextareaAutosize from 'vue-textarea-autosize';
import Flatpickr from 'flatpickr/dist/flatpickr.min.js';
import VueChatScroll from 'vue-chat-scroll';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
import 'prismjs';
import 'prismjs/themes/prism.css';
import 'vue-select/dist/vue-select.css';
import VModal from 'vue-js-modal';
import GSignInButton from 'vue-google-signin-button';

import moment from 'moment';
import 'moment/locale/ru';
import 'moment/locale/en-ie';

// sockets

import VueSocketIO from 'vue-socket.io';

/*
* multi languages
*/

import VueI18n from 'vue-i18n';

import * as en from './configs/languages/en';
import * as ru from './configs/languages/ru';

Vue.use(new VueSocketIO({
  debug: false,
  connection: 'https://api.emika.ai/all',
}));

Vue.use(VueI18n);
Vue.config.productionTip = false;

const i18n = new VueI18n({
  locale: 'en', // set locale
  fallbackLocale: 'en',
  messages: { en: en.default, ru: ru.default }, // set locale messages
});

Vue.use(TextareaAutosize);
Vue.use(VueLodash, { lodash: lodash });
Vue.use(VueChatScroll);
Vue.use(GSignInButton);
Vue.use(VModal);

Vue.use(require('vue-moment'), {
  moment,
});

// Vue.prototype.$select2 = Select2;
Vue.directive('select', {
  twoWay: true,
  bind: function (el, binding, vnode) {
    // eslint-disable-next-line no-undef
    $(el).select2().on('select2:select', (e) => {
      el.dispatchEvent(new Event('change', { target: e.target }));
    });
    // eslint-disable-next-line no-undef
    $(el).select2().on('select2:unselect', (e) => {
      el.dispatchEvent(new Event('change', { target: e.target }));
    });
  },
});

Vue.prototype.$flatpickr = Flatpickr;
Vue.prototype.$api = api;

Vue.use(VueNoty, {
  timeout: 4000,
  progressBar: true,
  layout: 'bottomRight',
  closeWith: ['click', 'button'],
  callbacks: {
    onTemplate: function () {
      if (this.options.type === 'success') {
        this.barDom.innerHTML = '<div class="noty_body" style="background-color: #4DA475">' + this.options.text + '<div>';
      }
      if (this.options.type === 'show') {
        this.barDom.innerHTML = '<div class="noty_body" style="background-color: #4DA475">' + this.options.text + '<div>';
      }
    },
  },
});

Vue.use(vueResource);

/*
 * By extending the Vue prototype with a new '$bus' property
 * we can easily access our global event bus from any child component.
 */

const eventBus = new Vue();
Object.defineProperty(Vue.prototype, '$bus', {
  get () {
    return eventBus;
  },
});

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
